export class InputTypes {
    static input_type_date: string = 'date';
    static input_type_datetime_local: string = 'datetime-local';
    static input_type_email: string = 'email';
    static input_type_month: string = 'month';
    static input_type_number: string = 'number';
    static input_type_password: string = 'password';
    static input_type_search: string = 'search';
    static input_type_tel: string = 'tel';
    static input_type_text: string = 'text';
    static input_type_time: string = 'time';
    static input_type_url: string = 'url';
    static input_type_week: string = 'week';
}
